import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import { uniqueID, withCommas } from '../common/Utils';
import { numToKor } from '../common/numToKor';
import useRouter from '../hook/useRouter';
import { IStockItem } from '../interface/IPrice';
import { RootState } from '../store';

const itemStyle = {
    display: 'inline-block',
    cursor: 'context-menu',
};

export const PriceItemStockItem = ({ it }: { it: IStockItem }) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const { changeParam } = useRouter([]);
    const service = useSelector((state: RootState) => state.main.config.service);
    const numChangeFn = service === 'lms' ? numToKor : withCommas;
    const [options, optionsSet] = useState<JSX.Element[]>([]);
    const placeholderStr = service === 'l2m' ? l10n['price.divinitystage2'] : l10n['price.divinitystage'];

    useEffect(() => optionsSet(MakeOptions(it)), [it]);

    const onDetailShow = () => {
        changeParam({
            detail: `item_${it.itemId}_${it.enchantLevel}_${it.serverId}`,
        });
    };

    return (
        <li className={options.length > 0 ? 'has-option' : ''}>
            <span className="tradeableitems-name">
                <button className="btn-item" onClick={onDetailShow}>
                    <strong
                        className="name"
                        data-itemgrade={it.grade}
                        data-detailshow={it.itemId.toString()}
                        data-enchant={it.enchantLevel.toString()}
                        data-svrid={it.serverId}
                        data-areas="시세_리스트_매물이름_클릭"
                    >
                        {/* {it.enchantLevel > 0 ? `+${it.enchantLevel} ` : ''} */}
                        {it.itemName}
                        {it.blessingLevel ? ` (${placeholderStr.replace('{N}', it.blessingLevel.toString())})` : ``}
                        {it.quantity > 1 ? <span className="qty">({numChangeFn(it.quantity)})</span> : ``}
                    </strong>
                </button>
            </span>
            {options.length > 0 ? (
                <span className="tradeableitems-option" style={{ display: 'block' }}>
                    {options}
                </span>
            ) : null}
            <span className="tradeableitems-price">
                {it.world ? <i className="ico-world"></i> : ''}
                <i className="ico-price"></i>
                <strong className="price">{numChangeFn(it.salePrice)}</strong>
            </span>
        </li>
    );
};

const MakeOptions = (it: IStockItem) => {
    const opArr: JSX.Element[] = [];

    if (it.blessingOption) {
        const tooltipId = `my-tooltip-${uniqueID('')}-${it.itemId}`;
        opArr.push(
            <>
                <strong style={itemStyle} data-tooltip-id={tooltipId}>
                    {it.blessingOption}
                </strong>
                <Tooltip offset={5} id={tooltipId} html={it.blessingOptionDescription.replace(/\n/gi, '<br/>')} />
            </>
        );
    }

    if (it.soulgemEffects?.length > 0) {
        it.soulgemEffects.map((it, idx) => {
            const tooltipId = `my-tooltip-${uniqueID('')}-${it.soulgemName + idx}`;
            const soulgemOption = it.soulgemSkillOptionName
                ? `<br><br>[${it.soulgemSkillOptionName}]<br>${it.soulgemSkillOptionDescription}`
                : '';

            opArr.push(
                <>
                    <strong style={itemStyle} data-tooltip-id={tooltipId}>
                        {it.soulgemName}
                    </strong>
                    <Tooltip offset={5} id={tooltipId} html={it.soulgemStatOption.map((op) => op).join('<br>') + soulgemOption} />
                </>
            );
        });
    }

    if (it.refinements?.length > 0) {
        it.refinements.map((it) => opArr.push(<span style={{ display: 'inline-block' }}>{it}</span>));
    }

    const newArray: JSX.Element[] = [];
    opArr.forEach((item, index) => {
        newArray.push(item);
        if (index !== opArr.length - 1) {
            newArray.push(<>,&nbsp;</>);
        }
    });

    return newArray;
};
